import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CompareVehicles from "./CompareVehicles";

const Features = ({ icons, small, medium, OBJ }) => {
  const [active, setActive] = useState(0);

  const products = useSelector((state) => state?.Landing?.products);

  const trucks = useSelector((state) => state?.Landing?.trucks);

  const getRef = (ref) => {
    if (ref) setActive(1);
    else setActive(0);
  };

  return (
    <Grid
      container
      spacing={2}
      style={{
        width: "auto",
        background: "#1C1C1C",
        padding: small ? 0 : "0 24px",
      }}
    >
      {/* <Tabs active={active} small={small} medium={medium} />
      <Grid
        container
        spacing={2}
        sx={{ padding: small ? 0 : "40px 80px" }}
        id="features"
      >
        <Grid
          item
          xs={12}
          md={3}
          style={{
            alignSelf: "center",
            display: "flex",
            justifyContent: "center",
            flexDirection: small ? "row" : "column",
            marginTop: small && SIZES.twenty,
          }}
        >
          <FeatureList getFeature={getFeature} small={small} />
        </Grid>
        <Grid item xs={12} md={9}>
          <FeatureDisplay
            small={small}
            banners={images}
            images={[Feature1, Feature2, Feature3, Feature4]}
            banner={banners?.[banners?.length - 1]}
            feature={featureItem}
          />
        </Grid>
      </Grid> */}

      {OBJ?.length > 0 && (
        <CompareVehicles
          OBJ={OBJ[0]?.attributes?.JSON}
          trucks={trucks}
          getRef={getRef}
          products={products}
          icons={icons}
          small={small}
          medium={medium}
        />
      )}
    </Grid>
  );
};

export default Features;
